var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Modal', {
    attrs: {
      "title": "删除新客户开发"
    },
    on: {
      "on-ok": _vm.deleteCustomerDevelopMethod
    },
    model: {
      value: _vm.deleteCustomerDevelopModal,
      callback: function ($$v) {
        _vm.deleteCustomerDevelopModal = $$v;
      },
      expression: "deleteCustomerDevelopModal"
    }
  }, [_c('div', [_vm._v("确认要删除此条新客户开发吗？")])]), _c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "30px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchCustomerDevelop
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('Select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "状态筛选",
      "label-in-value": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.choseStatus
    },
    model: {
      value: _vm.selectedStatu,
      callback: function ($$v) {
        _vm.selectedStatu = $$v;
      },
      expression: "selectedStatu"
    }
  }, _vm._l(_vm.status, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1), _c('Select', {
    staticStyle: {
      "width": "150px",
      "margin": "0 10px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "开发人员筛选"
    },
    on: {
      "on-open-change": _vm.getSearchList,
      "on-change": _vm.choseSalesVisible,
      "on-query-change": _vm.filterUserList
    },
    model: {
      value: _vm.salesVisible,
      callback: function ($$v) {
        _vm.salesVisible = $$v;
      },
      expression: "salesVisible"
    }
  }, _vm._l(_vm.salesVisibleMember, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c('Cascader', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "data": _vm.pca,
      "placeholder": "城市筛选",
      "render-format": _vm.citySelect,
      "change-on-select": ""
    },
    on: {
      "on-visible-change": _vm.showCity,
      "on-change": _vm.chooseCity
    }
  })], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('div', {
    staticClass: "page-wrap"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadCustomerDevelop
    }
  })], 1), _vm.arrayIntersection(['salesAssist'], _vm.user.simpleRole).length > 0 ? _c('Button', {
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.UploadFileModal.openModal();
      }
    }
  }, [_vm._v("导入已开发用户")]) : _vm._e(), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreateCustomerDevelopDrawer();
      }
    }
  }, [_vm._v("新增客户开发")])], 1)], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.tableData,
      "height": _vm.tableHeight
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function (_ref) {
        var row = _ref.row;
        return [_c('Poptip', {
          attrs: {
            "placement": "bottom",
            "word-wrap": "",
            "width": "400",
            "trigger": "hover",
            "content": row.content
          }
        }, [_c('p', {
          staticClass: "content-item"
        }, [_vm._v(_vm._s(row.content))])])];
      }
    }, {
      key: "operate",
      fn: function (_ref2) {
        var row = _ref2.row;
        return [_c('Dropdown', {
          attrs: {
            "trigger": "hover",
            "transfer": ""
          },
          on: {
            "on-click": _vm.clickActionDropDown
          }
        }, [_c('a', [_vm._v(" 操作 "), _c('Icon', {
          attrs: {
            "type": "ios-arrow-down"
          }
        })], 1), _c('DropdownMenu', {
          attrs: {
            "slot": "list"
          },
          slot: "list"
        }, [_c('div', [_c('DropdownItem', {
          staticStyle: {
            "color": "#ed4014"
          },
          attrs: {
            "name": `Delete,${row._id},${row.status}`
          }
        }, [_vm._v("删除")])], 1)])], 1)];
      }
    }])
  })], 1), _c('CustomerDevelopDrawer', {
    ref: "CustomerDevelopDrawer",
    attrs: {
      "indexFilter": _vm.filterQuery
    }
  }), _c('UploadFileModal', {
    ref: "UploadFileModal"
  }), _c('CreateCustomerDevelop', {
    ref: "CreateCustomerDevelop",
    attrs: {
      "loadCustomerDevelop": _vm.loadCustomerDevelop
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }